<template>
  <div>
    <!--  :getFormData="fromData":isNotSearch="isNotSearch"
      :queryParamsAppend="queryParamsAppend" @reset="reset"-->
    <list
      row-key="ProductId"
      ref="list"
      unit="存货"
      urlHash="basedata/inventory/archives"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :get-data-func="api.pList"
     :get-form-data="fromData"       
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="存货分类">
          <tree-select
            ref="treeSelect"
            @input="nodeSelect"
            :clearable="true"
          />
        </el-form-item> -->
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import formColumn from "@/data/basedata/inventory/archives/form.json";
import treeSelect from "@/components/basedata/inventory/types/select";

export default {
  mixins: [listMixin],
  components: { list, treeSelect },
  data() {
    return {
      api: require("@/api/ba/product").default,
      fromData: formColumn.Data,
      trendShow: true,
      isNotSearch: false,
      queryParamsAppend: {IdChain:null},
    };
  },

  methods: {
    nodeSelect(val){
      this.queryParamsAppend.IdChain = val
    },
    reset(){
      this.$refs.treeSelect.clear();
    },
    getFormData() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.fromData.map((item) => {
            item.show = ShowField.indexOf(item.field) !== -1 ? true : false;
          });
        }
      });
    },
    onExport() {
    
      let params = this.$refs.list.getQueryData();
      if(this.queryParamsAppend.IdChain){
        params.IdChain=this.queryParamsAppend.IdChain;
      }
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>